import { Map as IMap } from 'immutable';


const initialState = {
    isCurrencyPickerEnabled: false,
    isManageGiftcardsEnabled: false,
    isCartIconEnabledForMobile: true
};


export const SET_CURRENCY_PICKER_ENABLE_STATUS = '@@storefront/SET_CURRENCY_PICKER_ENABLE_STATUS';
export const SET_MANAGE_GIFTCARDS_ENABLE_STATUS = '@@storefront/SET_MANAGE_GIFTCARDS_ENABLE_STATUS';
export const SET_CART_ICON_ENABLED_FOR_MOBILE_STATUS = '@@storefront/SET_CART_ICON_ENABLED_FOR_MOBILE_STATUS';


const currencyPickerReducer = (state = IMap(initialState), action) => {
    switch (action.type) {
        case SET_CURRENCY_PICKER_ENABLE_STATUS: {
            const { payload: { isCurrencyPickerEnabled = false } = {} } = action;
            return state.set('isCurrencyPickerEnabled', isCurrencyPickerEnabled);
        }
        case SET_MANAGE_GIFTCARDS_ENABLE_STATUS: {
            const { payload: { isManageGiftcardsEnabled = false } = {} } = action;
            return state.set('isManageGiftcardsEnabled', isManageGiftcardsEnabled);
        }
        case SET_CART_ICON_ENABLED_FOR_MOBILE_STATUS: {
            const { payload: { isCartIconEnabledForMobile = true } = {} } = action;
            return state.set('isCartIconEnabledForMobile', isCartIconEnabledForMobile);
        }
        default:
    }
    return state;
};


export const setIsCurrencyPickerEnabled = payload => ({
    type: SET_CURRENCY_PICKER_ENABLE_STATUS,
    payload
});

export const setIsManageGiftcardsEnabled = payload => ({
    type: SET_MANAGE_GIFTCARDS_ENABLE_STATUS,
    payload
});

export const setIsCartIconEnabledForMobile = payload => ({
    type: SET_CART_ICON_ENABLED_FOR_MOBILE_STATUS,
    payload
});


export default currencyPickerReducer;
